import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    name: 'Heritage Varsity Jacket',
    price: 189,
    image: 'https://public.readdy.ai/ai/img_res/8d51aacc0c74d87c9d4ca7c0056e1f35.jpg',
    featured: true
  },
  {
    id: 2,
    name: 'Northside Hoodie',
    price: 78,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20hoodie%20flat%20lay%20on%20pure%20black%20background%20with%20embroidered%20logo%20streetwear%20product%20photography%20minimal%20clean%20studio%20shot%20high%20quality%20fabric%20texture&width=600&height=800&seq=product-hoodie-1&orientation=portrait',
    featured: false
  },
  {
    id: 3,
    name: 'Culture Tee',
    price: 45,
    image: 'https://readdy.ai/api/search-image?query=black%20graphic%20t-shirt%20with%20bold%20white%20typography%20hanging%20on%20pure%20black%20background%20streetwear%20product%20photography%20minimal%20studio%20aesthetic%20premium%20cotton%20fabric&width=600&height=800&seq=product-tee-1&orientation=portrait',
    featured: false
  },
  {
    id: 4,
    name: 'Unity Joggers',
    price: 85,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20jogger%20pants%20flat%20lay%20on%20pure%20black%20background%20streetwear%20product%20photography%20minimal%20clean%20studio%20shot%20tapered%20fit%20high%20quality%20fabric&width=600&height=800&seq=product-joggers-1&orientation=portrait',
    featured: false
  }
];

export default function NewArrivals() {
  return (
    <section className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1600px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-gray-500 text-xs font-bold tracking-[0.15em] uppercase mb-4">JUST DROPPED</p>
          <h2 className="text-6xl md:text-7xl font-black text-white">New Arrivals</h2>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className={`group relative bg-[#1A1A1A] rounded-xl overflow-hidden hover:-translate-y-2 transition-all duration-300 ${
                index === 0 ? 'md:col-span-2 md:row-span-1' : ''
              }`}
              data-product-shop
            >
              <div className={`relative overflow-hidden ${index === 0 ? 'h-[600px]' : 'h-[500px]'}`}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                  <span className="text-white font-bold text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                    SHOP NOW
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-white text-lg font-semibold mb-2">{product.name}</h3>
                <p className="text-gray-400 text-base">${product.price}</p>
                
                <button className="mt-4 w-full border border-white/20 text-white text-sm py-3 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-white hover:text-black font-medium whitespace-nowrap">
                  QUICK VIEW
                </button>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-16">
          <Link 
            to="/new-arrivals" 
            className="inline-flex items-center gap-2 text-white text-sm font-bold tracking-wide hover:underline whitespace-nowrap"
          >
            VIEW ALL NEW ARRIVALS <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}